import { View, ProgressView } from "@gaming/srvg-classes-core";
import { GroupAndRosterView } from "../GroupAndRosterView";

export class PostGroupOverlay extends View {

    groupAndRosterView: GroupAndRosterView;
    progressView: ProgressView;

    constructor( options ) {
        options = options || {};
        super( options );

        this.groupAndRosterView = this.addSubView( new GroupAndRosterView( {} ) );
        this.progressView = this.addSubView( new ProgressView( { selector: this.selector + ' .progressView'} ) );
    }

    show( animate?:boolean ) {
        this.groupAndRosterView.startSubViewRotation( srvg.timelinePhases.post_group.length/2 );
        super.show( animate );
    }

    hide( animate?:boolean ) {
        this.groupAndRosterView.stopSubViewRotation();
        super.hide( animate );
    }
}